import { Routes, Route } from "react-router-dom";
import ServicesListPage from "./list";
import AddServicePage from "./add";
import EditServicePage from "./edit";
import ServiceShowPage from "./show";

function ServicesPage() {
	return (
		<Routes>
			<Route path="/" element={<ServicesListPage />} />
			<Route path="list" element={<ServicesListPage />} />
			<Route path="add" element={<AddServicePage />} />
			<Route path="/:id/edit" element={<EditServicePage />} />
			<Route path="/:id" element={<ServiceShowPage />} />
		</Routes>
	);
}

export default ServicesPage;
